import Head from 'next/head'

import type { FC, ReactNode } from 'react'
import type { SeoProps } from '@/types'

import { useRouter } from 'next/router'
import { siteConfig } from '@/constants/site'

const absolute = (path: string): string => (path.startsWith('http') ? path : `${siteConfig.url}${path}`)

export const Seo: FC<SeoProps> = ({
    title,
    description = siteConfig.description,
    ogImage = siteConfig.ogImage,
    noIndex = false
}): ReactNode => {
    const router = useRouter()
    const pageTitle = title ? `${title} - ${siteConfig.name}` : siteConfig.name
    const path = router.asPath.split('#')[0].split('?')[0]
    const url = absolute(path === '/' ? '' : path)
    const image = absolute(ogImage)

    return (
        <Head>
            <title>
                {pageTitle}
            </title>

            <meta name='description' content={description} />
            <link rel='canonical' href={url || siteConfig.url} />
            {noIndex && <meta name='robots' content='noindex' />}
            <meta property='og:site_name' content={siteConfig.name} />
            <meta property='og:locale' content='en_GB' />
            <meta property='og:title' content={pageTitle} />
            <meta property='og:description' content={description} />
            <meta property='og:type' content='website' />
            <meta property='og:url' content={url || siteConfig.url} />
            <meta property='og:image' content={image} />
            <meta property='og:image:alt' content='The CosmicLens observatory dome on its hill beneath the Milky Way' />
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:title' content={pageTitle} />
            <meta name='twitter:description' content={description} />
            <meta name='twitter:image' content={image} />
        </Head>
    )
}
